import gql from 'graphql-tag'

import axios from '../services/Request'
import client from '../services/ApolloClient'
import {
  getCurrentUserObjectFromToken
} from '../utils'

export const USERS_FAIL_LOGIN = 'USERS_FAIL_LOGIN'
export const USERS_REQUEST_LOGIN = 'USERS_REQUEST_LOGIN'
export const USERS_SUCCESS_LOGIN = 'USERS_SUCCESS_LOGIN'

export const USERS_AUTHENTICATE = 'USERS_AUTHENTICATE'
export const USERS_LOGOUT = 'USERS_LOGOUT'

const dependencies = { axios }

export const requestUsersFail = err =>
  ({
    type: USERS_FAIL_LOGIN,
    err
  })

export const requestUsers = () =>
  ({
    type: USERS_REQUEST_LOGIN
  })

export const requestUsersSuccess = user =>
  ({
    type: USERS_SUCCESS_LOGIN,
    user
  })

export const requestUsersAuthenticate = () =>
  ({
    type: USERS_AUTHENTICATE
  })

export const requestUsersLogout = () =>
  ({
    type: USERS_LOGOUT
  })

export const login = (input, injection) => {
  return dispatch => {
    dispatch(requestUsers())
    return client.mutate({
      mutation: gql`
        mutation Login($input: LoginInput!) {
          login(input: $input) {
            token
          }
        }
      `,
      variables: { input }
    }).then(
      ({ data }) => getCurrentUserObjectFromToken(data.login.token),
      (error) => dispatch(requestUsersFail(error))
    ).then((user) => {
      localStorage.setItem('jwt', user.token)
      return user
    })
      .then(data => dispatch(requestUsersSuccess(data)))
  }
}

export const logout = (user, injection) => {
  const { axios } = { ...dependencies, injection }
  localStorage.removeItem('jwt')

  return dispatch => {
    dispatch(requestUsersLogout())
  }
}

export const authenticate = (accessToken, injection) => {
  const { axios } = { ...dependencies, injection }

  return dispatch =>
    axios(false).get('/authenticate', { params: { accessToken } })
      .then(({ data: { status } }) => {
        if (!status) {
          dispatch(requestUsersLogout())
        }
      })
}



// WEBPACK FOOTER //
// ./src/actions/users.js